import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import sdd from "../assets/sdd.webp";
import TimezoneClock from "../components/TimeZone";
import { openCookiePreferences } from "@/lib/analytics";

export default function Footer() {
  const { t } = useTranslation();

  const whatsappHref = `https://wa.me/5511967611652?text=${encodeURIComponent(
    t("contact.whatsappMessage"),
  )}`;

  return (
    <footer className="surface-navy text-white font-light overflow-hidden rounded-t-4xl h-svh p-4 md:p-8 flex flex-col justify-between">
      <div className="flex flex-col">
        <div className="w-full mt-2 border-white/15 dark:border-[#90909033] border-1"></div>
        <div className="flex flex-col mt-8 md:flex-row justify-between">
          <p className="w-auto md:w-110 text-[24px] tracking-tight">
            {t("footer.headline")}
          </p>

          <div className="flex gap-x-16">
            <nav className="flex flex-col gap-4 mt-8 md:mt-0 :gap-6">
              <h4 className="flex font-normal">{t("common.navigate")}</h4>

              <div className="flex flex-col gap-1 text-white/60 dark:text-[#737373]">
                <Link to="/" className="hover:text-white">
                  {t("common.home")}
                </Link>
                <Link to="/#servicos" className="hover:text-white">
                  {t("common.services")}
                </Link>
                <Link to="/portfolio" className="hover:text-white">
                  {t("common.portfolio")}
                </Link>
              </div>
            </nav>

            <nav className="flex flex-col gap-4 mt-8 md:mt-0 :gap-6">
              <h4 className="flex font-normal">{t("common.social")}</h4>

              <div className="flex flex-col gap-1 text-white/60 dark:text-[#737373]">
                <a
                  href="https://www.instagram.com/suportededomingo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit"
                >
                  <p className="hover:text-white">{t("common.instagram")}</p>
                </a>

                <a
                  href="https://www.linkedin.com/company/suporte-de-domingo/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit"
                >
                  <p className="hover:text-white">{t("common.linkedin")}</p>
                </a>

                <a
                  href={whatsappHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit"
                >
                  <p className="hover:text-white">{t("common.whatsapp")}</p>
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center">
        <a
          href="https://suportededomingo.com.br/"
          aria-label="Suporte de Domingo"
          className="w-10/12 transition-opacity hover:opacity-80"
        >
          <img
            src={sdd}
            alt="logo Suporte de Domingo"
            width={1312}
            height={530}
            className="select-none mb-8 w-full h-auto"
          />
        </a>
      </div>
      <div className="flex flex-col w-full items-center text-center gap-2 md:flex-row justify-between">
        <p>
          {t("footer.copyright", { year: new Date().getFullYear() })}{" "}
          <span className="font-normal">{t("footer.rights")}</span>
        </p>

        <button
          type="button"
          onClick={openCookiePreferences}
          className="cursor-pointer text-white/60 hover:text-white transition-colors dark:text-[#737373] dark:hover:text-white"
        >
          {t("cookies.preferences")}
        </button>

        <TimezoneClock timeZone="America/Sao_Paulo" />
      </div>
    </footer>
  );
}
